import { useApiRequest } from "./useApiRequest"

export interface Calendar {
  id?: number
  uuid: string
  name: string
  organization_id: string
  position: number
}

export interface SortCalendarsBody {
  ids: string[]
  positions: number[]
}

export const useSortCalendars = (subdomain: string) => {
  const getUpload = useApiRequest<Calendar[], SortCalendarsBody>({
    method: "PATCH",
    url: `//${process.env.REACT_APP_API_BASE_DOMAIN}/api/organizations/${subdomain}/calendars/sort`,
  })
  return getUpload
}
